module.exports = __webpack_public_path__ + "img/attractions.46ccd22d.svg";